<template>
  <div v-if="!loading">
    <lesson-item-desktop v-if="screenType === 'desktop'" :item="item" :class-id="classId"
                         :course-id="courseId"></lesson-item-desktop>
    <lesson-item-mobile v-else :item="item" :class-id="classId" :course-id="courseId"></lesson-item-mobile>
  </div>
</template>

<script>
import LessonItemDesktop from "@/components/Pages/Desktop/Dashboard/Lessons/LessonItemDesktop";
import LessonItemMobile from "@/components/Pages/Mobile/Dashboard/Lessons/LessonItemMobile";

export default {
  name: "LessonItemMain",
  components: {LessonItemMobile, LessonItemDesktop},
  data() {
    return {
      item: null,
      loading: true,
      refreshingItem: false,
      lastItemRefreshAt: 0,
      classId: null,
      courseId: null,
      screenType: window.screen.width < 500 ? 'mobile' : window.screen.width < 1000 ? 'tablet' : 'desktop',
    }
  },
  methods: {
    getItem() {
      if (this.refreshingItem) {
        return Promise.resolve()
      }

      this.refreshingItem = true

      return window.axios.get('student/courses/lessons/item/full/' + this.$route.params.itemId + '/' + this.courseId).then((res) => {
        this.loading = false
        this.item = res.data.data
      }).catch((err)=>{
        this.openSnackbar(err.response.data.message, '#F1416C')
        let self = this
        window.setTimeout(function () {
          self.$router.push('/dashboard/subscriptions')
        }, 3000)
      }).finally(() => {
        this.refreshingItem = false
      })
    },
    refreshItemAfterDictation(force = false) {
      if (!force && document.hidden) {
        return
      }

      const now = Date.now()
      if (now - this.lastItemRefreshAt < 1000) {
        return
      }

      this.lastItemRefreshAt = now
      this.getItem()
    },
    handleVisibilityChange() {
      if (!document.hidden) {
        this.refreshItemAfterDictation()
      }
    },
    handleDictationProgressChange(event) {
      if (event.key !== 'dorakk:dictation-progress-updated' || !event.newValue) {
        return
      }

      try {
        const detail = JSON.parse(event.newValue)
        if (
            String(detail.itemId) === String(this.$route.params.itemId) &&
            String(detail.classId) === String(this.$route.params.classId)
        ) {
          this.refreshItemAfterDictation(true)
        }
      } catch (error) {
        console.error('Error parsing dictation progress update:', error)
      }
    }
  },
  mounted() {
    this.classId = this.$route.params.classId
    this.courseId = this.$route.params.courseId
    this.getItem()
    window.addEventListener('focus', this.refreshItemAfterDictation)
    window.addEventListener('storage', this.handleDictationProgressChange)
    document.addEventListener('visibilitychange', this.handleVisibilityChange)
  },
  beforeDestroy() {
    window.removeEventListener('focus', this.refreshItemAfterDictation)
    window.removeEventListener('storage', this.handleDictationProgressChange)
    document.removeEventListener('visibilitychange', this.handleVisibilityChange)
  }
}
</script>

<style scoped>

</style>
